import React, { createContext, useContext } from 'react';
import useDeviceType from '../hooks/useDeviceType';

const DeviceContext = createContext({ isMobilePhone: false, isDesktop: true });

export const DeviceProvider = ({ children }) => {
  const device = useDeviceType();
  return <DeviceContext.Provider value={device}>{children}</DeviceContext.Provider>;
};

export const useResponsivePortal = () => useContext(DeviceContext);

export const ResponsivePage = ({ desktop: DesktopComponent, mobile: MobileComponent }) => {
  const { isMobilePhone } = useResponsivePortal();
  const Component = isMobilePhone ? MobileComponent : DesktopComponent;
  return <Component />;
};
